<template>
  <div style="margin-left: 20">
    <div class="container">
      <div class="row">
        <table>
          <tr>
            <td>
              <h4 style="margin-top: 10; margin-left: 50">
                Mumbai Task Level Feedback Form
              </h4>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <form id="form_id" ref="form" @submit.prevent="processForm">
      <div class="container">
        <div class="row">
          <table class="table-horizontal" width="50%" height="20">
            <tbody>
              <tr>
                <td><strong>Date</strong></td>
                <td>
                  <input
                    class="mumbai grayout"
                    type="date"
                    name="feeddate"
                    v-model="feeddate"
                    required
                    disabled
                    style="width: 273px"
                  />
                </td>
              </tr>
              <tr>
                <td><strong>Group Name</strong></td>
                <td>
                  <input
                    class="mumbai grayout"
                    readonly="true"
                    v-model="group"
                    @change="onGroupChange"
                  />
                </td>
              </tr>
              <tr>
                <td><strong>Deal/Company Name</strong></td>
                <td>
                  <input
                    class="mumbai"
                    type="text"
                    name="companyname"
                    size="29"
                    v-model="companyname"
                    required
                  />
                </td>
              </tr>
              <tr>
                <td><strong>Function Supported</strong></td>
                <td>
                  <div id="functionsupporteddiv">
                    <select
                      required
                      class="mumbai"
                      v-model="functionSupported"
                      @click="onFunctionChange"
                    >
                      <option
                        v-for="functionSupported in functionSupporteds"
                        v-bind:key="functionSupported.id"
                      >
                        {{ functionSupported }}
                      </option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>Tasks Performed</strong></td>

                <td>
                  <div id="divTaskPerformed">
                    <td>
                      <input
                        list="tasksperformed"
                        name="tasksperformed"
                        class="mumbai"
                        v-model="task_performed"
                        required
                      />
                      <datalist id="tasksperformed" style="width: 273px">
                        <option value="Dealview"></option>
                        <option value="Chronicle"></option>
                      </datalist>
                    </td>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>Primary Analyst Email ID</strong></td>
                <td>
                  <combobox
                    :emails="emails"
                    v-model="usanalystid"
                    class="mumbai"
                    required
                  ></combobox>
                </td>
              </tr>
              <tr>
                <td><strong>Mumbai Analyst Email ID</strong></td>
                <td>
                  <input
                    class="mumbai"
                    type="email"
                    name="mumbaianalystid"
                    v-model="mumbaianalystid"
                    size="29"
                    required
                    disabled
                  />
                </td>
              </tr>

              <tr id="Comment">
                <td><strong>Comment</strong></td>
                <td>
                  <textarea
                    style="width: 273px; margin-top: 10px"
                    v-model="comment"
                    name="comment"
                  ></textarea>
                  <div id="commentdiv">
                    <span v-on:click="expandComment" style="color: blue"
                      ><u>click here to expand comment box</u></span
                    >
                    <div id="tooltip1" class="tooltip1">
                      <textarea
                        style="width: 100%; height: 100%"
                        v-model="comment"
                      >
                      </textarea>
                      <button type="button" v-on:click="closeComment">
                        Close
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <br />
              <tr id="Attach">
                <td><strong>Attach file</strong></td>
                <td>
                  <input
                    type="file"
                    id="files"
                    ref="files"
                    multiple
                    v-on:change="handleFilesUpload"
                  />
                  <div class="large-12 medium-12 small-12 cell">
                    <div
                      v-for="(file, key) in files"
                      class="file-listing"
                      v-bind:key="key.id"
                      v-bind:id="key"
                    >
                      {{ file.name }}
                      <span class="remove-file" v-on:click="removeFile(key)"
                        >Remove</span
                      >
                    </div>
                  </div>
                  <!-- <br> -->
                  <div class="large-12 medium-12 small-12 cell">
                    <button v-on:click="addFiles()">Add Files</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <button
            style="margin-top: 20px"
            type="submit"
            :disabled="isnotActive"
            v-on:click="submitForm"
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
import moment from "moment";
import { axiosInit } from "../axios-interceptor";
import combobox from "@/reusableComponents/comboBox";

const S3_DIRECTORY = "CRS-mumbai-feedback-files/";
export default {
  name: "HelloWorld",
  props: { msg: String },
  components: { combobox },
  data() {
    return {
      isnotActive: false,
      message: false,
      //file:'',
      files: [],
      attach: [],
      feeddate: "",
      companyname: "",
      functionSupported: "",
      group: "",
      task_performed: "",
      usanalystid: "",
      mumbaianalystid: "",
      par_due_date: "",
      comment: "",
      function_CRS: ["Research"],
      functionSupporteds: [],
      function_json: {
        CRS: ["Research"],
      },
      task_performeds: [],
      task_json: {
        CRS: { Research: ["Dealview", "Chronicle"] },
      },
      objVal: {},
      emails: [],
      usAnalystFlag: false,
    };
  },
  async beforeCreate() {
    const getUrl = new URL(process.env.VUE_APP_BACKEND_API + "getEmails");
    this.groups = store.methods.getGroup();

    getUrl.searchParams.append("group", this.groups);

    const response = await axios
      .get(getUrl)
      .then((response) => (this.jsonresponse = response))
      .catch((error) => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
      });
    this.jsonresponse = response.data;
    this.emails = this.jsonresponse.map((data) => {
      return data["email"];
    });
  },
  created: function () {
    this.feeddate = moment().format("YYYY-MM-DD");
    this.groups = store.methods.getGroup();
    this.mumbaianalystid = store.methods.getUser();
    this.group = this.groups[0];

    this.functionSupporteds = Object.keys(this.task_json[this.group]);
    this.message = false;
  },
  methods: {
    buildS3FileName(fileName) {
      const safeName = String(fileName || "attachment");
      const ext = (safeName.match(/\.[^./]+$/) || [""])[0];
      const base =
        safeName.slice(0, safeName.length - ext.length) || "attachment";
      return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}__${encodeURIComponent(base)}${ext}`;
    },
    addFiles() {
      this.$refs.files.click();
    },
    checkFeedDate() {
      if (new Date(this.feeddate).getTime() >= new Date().getTime()) {
        alert("The Date must be Smaller or Equal to today date");
        this.feeddate = "";
      }
    },
    handleFilesUpload() {
      //this.file = this.$refs.file.files[0];
      let uploadedFiles = this.$refs.files.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        let fileObj = {};
        fileObj.name = uploadedFiles[i].name;
        fileObj.s3Name = this.buildS3FileName(uploadedFiles[i].name);
        fileObj.fileinstance = uploadedFiles[i];
        this.files.push(fileObj);
      }
      this.$refs.files.value = "";
    },
    removeFile(key) {
      this.files.splice(key, 1);
    },
    async getPresignedURL(fileName, contentType) {
      const url =
        process.env.VUE_APP_RCA_LAMBDA +
        "presigned_url?" +
        new URLSearchParams({
          fileName: S3_DIRECTORY + fileName,
          fileType: contentType || "application/octet-stream",
        });
      const s3PresignedURL = fetch(url, {
        method: "get",
        credentials: "include",
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("failed to get Presigned URL");
          }
        })
        .catch((err) => console.error(`${err.message}`));
      return s3PresignedURL;
    },
    upload(s3UploadURL = "", file, file_type) {
      // using fetch here because AWS requires to set correct content-type
      const resolvedType = file_type || "application/octet-stream";
      const res = fetch(s3UploadURL, {
        method: "PUT",
        headers: { "Content-Type": resolvedType },
        body: file,
      })
        .then((res) => {
          if (res.ok) {
            //console.log(`files uploaded to S3 sucessfully`)
            return res;
          } else {
            throw new Error("failed to upload file to S3 bucket");
          }
        })
        .catch((err) => {
          console.error(`${err.message}`);
          alert(err.message);
          throw new Error(err.message);
        });
      return res;
    },
    async UploadfilesToS3(files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        const respdata = await this.getPresignedURL(
          file.s3Name,
          file.fileinstance.type,
        );
        const newFile_name = file.name;
        const newFile = new File([file.fileinstance], newFile_name, {
          type: file.fileinstance.type,
        });
        await this.upload(respdata, newFile, newFile.type);
      }
      return this.files;
    },
    async submitForm() {
      axiosInit();

      this.usAnalystFlag = this.emails.includes(this.usanalystid.toLowerCase());
      if (
        this.$refs.form.checkValidity() &&
        /@morningstar.com$/.test(this.mumbaianalystid) &&
        /@morningstar.com$/.test(this.usanalystid) &&
        this.usAnalystFlag &&
        this.mumbaianalystid != this.usanalystid
      ) {
        let fileNames = [];
        this.isnotActive = true;
        if (this.files && this.files && this.files.length > 0) {
          console.log("init file upload");
          // upload files to s3
          await this.UploadfilesToS3(this.files);
        }

        for (let i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          fileNames.push(file.s3Name);
        }

        const formData = {
          feeddate: this.feeddate,
          grpname: this.group,
          companyname: this.companyname,
          functionsupported: this.functionSupported,
          tasksperformed: this.task_performed,
          usanalystid: this.usanalystid,
          mumbaianalystid: this.mumbaianalystid,
          comment: this.comment,
          files: fileNames,
        };

        axios
          .post(
            process.env.VUE_APP_BACKEND_API + "CRS/mumbaifeedback",
            formData,
            { withCredentials: true },
          )
          .then(function () {
            var x = document.cookie;
            console.log(JSON.stringify(x));
            alert("Feedback Request Submitted");
            window.location.href = process.env.VUE_APP_UI;
            console.log("SUCCESS!!");
          });
      } else {
        this.isnotActive = false;
        if (!this.usAnalystFlag) {
          alert("Enter correct Us Analyst email id");
          this.usanalystid = "";
        }
        if (this.usanalystid == this.mumbaianalystid) {
          alert(
            "Mumbai Analyst field and Primary Analyst field cannot be the same. ",
          );
          this.usanalystid = "";
          this.mumbaianalystid = store.methods.getUser();
        }
        if (
          !/@morningstar.com$/.test(this.mumbaianalystid) &&
          this.mumbaianalystid.length > 0
        ) {
          alert("Enter correct email id");
        }
        if (
          !/@morningstar.com$/.test(this.usanalystid) &&
          this.usanalystid.length > 0
        ) {
          alert("Enter correct email id");
        }
      }
    },
    onGroupChange() {
      this.functionSupporteds = Object.keys(this.task_json[this.group]);
      alert(this.functionSupporteds);
      this.message = false;

      this.onFunctionChange();
    },

    onFunctionChange() {
      // alert("in function supported"
      if (this.functionSupported != "") {
        this.task_performeds =
          this.task_json[this.group][this.functionSupported];
        this.task_performeds.push("");
      }
    },
    expandComment() {
      document.getElementById("tooltip1").style.transition =
        "opacity 0.5s ease";
      document.getElementById("tooltip1").style.visibility = "visible";
      document.getElementById("tooltip1").style.opacity = "1";
    },
    closeComment() {
      document.getElementById("tooltip1").style.transition =
        "opacity 0.5s ease";
      document.getElementById("tooltip1").style.visibility = "hidden";
      document.getElementById("tooltip1").style.opacity = "0";
    },
  },
};
</script>

<style scoped>
* {
  font-family:
    "Univers", HelveticaNeue, "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.select-editable {
  position: relative !important;
  background-color: white !important;
  border: solid grey 1px !important;
  width: 273px !important;
  height: 18px !important;
}

.select-editable select {
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
  border: none !important;
  width: 273px !important;
  margin: 0 !important;
  border-bottom: solid grey 1px !important;
  border-right: solid grey 1px !important;
  border-left: solid grey 1px !important;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.select-editable input {
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
  width: 100px !important;
  padding: 1px !important;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: none !important;
  border-bottom: solid grey 1px !important;
  border-right: solid grey 1px !important;
  border-left: solid grey 1px !important;
}

.select-editable select:focus,
.select-editable input:focus {
  outline: none !important;
}

.tooltip1 {
  width: 90%;
  height: 200px;
  visibility: hidden;
  background-color: #fff;
  padding: 20px;
  -webkit-box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.5s ease;
  position: absolute;
  top: 60%;
  left: 5%;
  z-index: 1;
}

#commentdiv {
  cursor: pointer;
}

#mumbai_div {
  margin-left: 20px;
}

#mumbai_title {
  text-align: left;
}
.mumbai {
  width: 273px;
  margin-top: 10px;
  height: 25px;
}

input[type="file"] {
  position: absolute;
  top: -500px;
}

span.remove-file {
  color: red;
  cursor: pointer;
  float: right;
}

.grayout {
  opacity: 0.6; /* Real browsers */
  filter: alpha(opacity = 60); /* MSIE */
}
</style>
